module.exports = __webpack_public_path__ + "img/copingpatternendtoend.f059e2bd.png";